import React, { useEffect, useState } from "react";
import Hoc from "../../../components/HOC";
import CustomDataTable from "../../../components/CustomDataTable";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CustomToolTip from "../../../components/ToolTip";
import { Formik, Form } from "formik";
import {
  MdCancel,
  MdEditDocument,
  MdInfo,
  MdDownload,
  MdAttachFile,
  MdVisibility,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown
} from "react-icons/md";
import {
  requestRejectedTimesheetListAction,
  setResetStateRejectedTimesheetList,
  setResetDownloadFileById,
  requestDownloadFileById,
  requestTimesheetsAction,
  setResetTimesheetsAction,
  requestTimesheetListAction,
} from "../../../Redux/TimeSheetState/TimeSheetActionCreator";
import Loader from "../../../components/Loader";
import { CalendarToday, InsertDriveFile } from "@mui/icons-material";
import { toast } from "react-toastify";
import { FcApproval } from "react-icons/fc";
import TextInput from "../../../components/TextInput";

function RejectedTimesheets() {
  const dispatch = useDispatch();
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const RejectedTimesheets = useSelector((state) => state.RejectedTimesheetsListReducer);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState(null); 
  const DownloadFileByIdReducer = useSelector(
    (state) => state.DownloadFileByIdReducer
  );
  const TimesheetAction = useSelector((state) => state.TimesheetsActionReducer);

  const handleEndDateSort = () => {
    const newSortBy = sortBy === 'asce' ? null : 'asce';
    setSortBy(newSortBy);
  };
  const columns = [
    {
      name: "Employee Name",
      selector: (row) => row.employeeName,
      sortable: true,
    },
    {
      name: "Project Name",
      selector: (row) => row.projectName,
      sortable: true,
    },
    {
      name: "Start Date",
      selector: (row) => moment(row.startDate).format("MM-DD-YYYY"),
      
    },
    {
      name: (
        <div className="flex items-center gap-2 cursor-pointer" onClick={handleEndDateSort}>
          <span>End Date</span>
          {sortBy === 'desc' ? (
            <MdKeyboardArrowUp className="w-4 h-4 text-black-600" />
          ) : (
            <MdKeyboardArrowDown className="w-4 h-4 text-gray-400" />
          )}
        </div>
      ),
      selector: (row) => moment(row.endDate).format("MM-DD-YYYY"),
      
    },
    {
      name: "Location",
      selector: (row) => row.workLocation,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Total Hours",
      selector: (row) => row.totalHours,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      sortable: true,
      hide: "sm",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="ml-2 flex space-x-4">

          <button
            onClick={() => handleApprove(row)}
            className="text-black hover:text-black"
          >
            <FcApproval size={24} data-tip data-for="registerTip" />
            <CustomToolTip id="registerTip" title="Approve" />
          </button>
          <button
            onClick={() => handleView(row)}
            className="text-primary hover:text-primaryDark"
          >
            <>
              <MdVisibility size={24} data-tip data-for="View" />
              <CustomToolTip id="View" title="Details" />
            </>
          </button>
        </div>
      ),
    },
  ];

  const handlePageChange = (page) => {
    dispatch(
      requestRejectedTimesheetListAction({
        status: "REJ",
        page: page,
        size: RejectedTimesheets?.size,
        employeeName: RejectedTimesheets?.employeeName || search,
        sortby: sortBy,
      })
    );
  };

  const handleRowsChange = (size) => {
    dispatch(requestRejectedTimesheetListAction({ 
      status: "REJ", 
      page: 0, 
      size: size, 
      employeeName: RejectedTimesheets?.employeeName || search,
      sortby: sortBy,
    }));
    // setSearch("");
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setIsModalOpenView(true);
  };


  const handleApprove = (row) => {
    dispatch(requestTimesheetsAction({ id: row.id, action: "approve" }));
    
   
  };

  useEffect(() => {
    if (TimesheetAction?.response && !TimesheetAction?.loading) {
      toast.success("Timesheet approved successfully");
      dispatch(requestRejectedTimesheetListAction({ 
        status: "REJ", 
        page: 0, 
        size: RejectedTimesheets?.size || 10,
        employeeName: RejectedTimesheets?.employeeName || search,
        sortby: sortBy,
      }));
      dispatch(setResetTimesheetsAction());
    }
    if (TimesheetAction?.error && !TimesheetAction?.loading) {
      toast.error("Failed to approve timesheet");
      dispatch(setResetTimesheetsAction());
    }
  }, [TimesheetAction]);

  useEffect(() => {
    if (RejectedTimesheets?.employeeName !== undefined && RejectedTimesheets?.employeeName !== search) {
      setSearch(RejectedTimesheets.employeeName);
    }
  }, [RejectedTimesheets?.employeeName]);

  useEffect(() => {
    dispatch(requestRejectedTimesheetListAction({ status: "REJ", page: 0, size: 10, employeeName: "" ,sortby: sortBy}));
    dispatch(setResetStateRejectedTimesheetList());
    dispatch(setResetTimesheetsAction());
    // dispatch(requestRejectedTimesheetListAction({ status: "REJ", page: 0, size: 10, employeeName: "" }));
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Reset the list data before making new search
      dispatch(setResetStateRejectedTimesheetList());
      dispatch(
        requestRejectedTimesheetListAction({
          status: "REJ",
          page: 0,
          size: RejectedTimesheets?.size,
          employeeName: search,
          sortby: sortBy,
        })
      );
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search]);

  // Separate useEffect for sort changes to maintain current page
  useEffect(() => {
    dispatch(setResetStateRejectedTimesheetList());
    dispatch(
      requestRejectedTimesheetListAction({
        status: "REJ",
        page: RejectedTimesheets?.page || 0,
        size: RejectedTimesheets?.size,
        employeeName: search,
        sortby: sortBy,
      })
    );
  }, [sortBy]);

  useEffect(() => {
    return () => {
     dispatch(setResetStateRejectedTimesheetList());
     dispatch(setResetTimesheetsAction());
    }
   }, []);

  const downloadFile = (fileId) => {
    dispatch(requestDownloadFileById({ tId: selectedRow.id, fileId: fileId }));
  };
  useEffect(() => {
    if (DownloadFileByIdReducer?.error && !DownloadFileByIdReducer?.loading) {
      toast.error(DownloadFileByIdReducer?.error?.message || "Failed to download file. Please try again.");
      dispatch(setResetDownloadFileById());
    }
  }, [DownloadFileByIdReducer]);

  useEffect(() => {
    if (DownloadFileByIdReducer?.response && !DownloadFileByIdReducer?.loading) {
      toast.success("File downloaded successfully!");
      dispatch(setResetDownloadFileById());
    }
  }, [DownloadFileByIdReducer]);
  const DetailsModal = ({ isOpen, onClose, data, onDownload, isDownloading }) => {
    if (!isOpen || !data) return null;

    // Use Formik for the modal form
    return (
      <Formik
        initialValues={{
          projectName: data?.projectName || '',
          employeeName: data?.employeeName || '',
          workLocation: data?.workLocation || '',
          status: data?.status || '',
          startDate: data?.startDate ? moment(data.startDate).format("MM-DD-YYYY") : '',
          endDate: data?.endDate ? moment(data.endDate).format("MM-DD-YYYY") : '',
          totalHours: data?.totalHours !== null && data?.totalHours !== undefined ? data.totalHours : '',
          remarks: data?.remarks || '',
        }}
        enableReinitialize
        onSubmit={() => {}} // No submit action, just for display
      >
        {({ values }) => (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-0 rounded-2xl shadow-2xl w-11/12 md:w-3/4 lg:w-2/4 relative z-50 max-h-[calc(100vh-0.5rem)] border border-gray-200">
              <div className="overflow-y-auto" style={{ maxHeight: '90vh' }}>
                {/* Modal Header */}
                <div className="sticky top-0 bg-white z-10 border-b border-gray-200 flex items-center justify-between px-6 py-4 gap-4 rounded-t-2xl">
                  <div className="flex items-center gap-3">
                    <h2 className="text-primary text-2xl font-bold tracking-tight">Timesheet Details</h2>
                  </div>
                  <button
                    onClick={onClose}
                    className="text-primary hover:text-primaryDark transition-colors p-2 rounded-full focus:outline-none absolute top-4 right-4"
                    type="button"
                    aria-label="Close"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <Form>
                  <div className="flex flex-col gap-6 mb-4 px-8 pt-6 pb-2">
                    {/* Row 1 */}
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.projectName}
                          name="projectName"
                          legend
                          isDisabled
                          placeholder="Project Name"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.employeeName}
                          name="employeeName"
                          legend
                          isDisabled
                          placeholder="Employee Name"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                    </div>
                    {/* Row 2 */}
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.workLocation}
                          name="workLocation"
                          legend
                          isDisabled
                          placeholder="Work Location"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.status}
                          name="status"
                          legend
                          isDisabled
                          placeholder="Status"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                    </div>
                    {/* Row 3 */}
                    <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.startDate}
                          name="startDate"
                          legend
                          isDisabled
                          placeholder="Start Date"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.endDate}
                          name="endDate"
                          legend
                          isDisabled
                          placeholder="End Date"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.totalHours !== undefined && values.totalHours !== null ? String(values.totalHours) : "0"}
                          name="totalHours"
                          legend
                          isDisabled
                          placeholder="Total Hours"
                          customClasses="bg-gray-50 border-gray-200"
                        />
                      </div>
                    </div>
                    {/* Rejection Reason */}
                    {values.status === 'REJ' && values.remarks && (
                      <div className="w-full">
                        <TextInput
                          handleChange={() => {}}
                          value={values.remarks}
                          name="remarks"
                          legend
                          isDisabled
                          placeholder="Rejection Reason"
                          customClasses="bg-red-50 text-rose-600 border-rose-200"
                        />
                      </div>
                    )}
                  </div>
                </Form>

                {/* Section Divider */}
                <div className="px-6">
                  <div className="border-t border-dashed border-gray-200" />
                </div>

                {/* Holidays & Attachments Section */}
                <div className="px-6 py-2">
                  <h2 className="text-primary text-lg font-semibold flex items-center">
                    <CalendarToday className="text-primary/70" fontSize="small" /> Holidays & Attachments
                  </h2>

                  {/* Holidays Section */}
                  <div className="my-2">
                    <div className="space-y-3">
                      {data.holidays?.length > 0 ? (
                        data.holidays.map((holiday, idx) => (
                          <div
                            key={holiday.id || idx}
                            className="p-3 border border-gray-100 rounded-lg bg-gray-50 shadow-sm flex flex-col sm:flex-row gap-2 sm:gap-4"
                          >
                            <div className="w-full">
                              <label className="block text-xs text-gray-500 mb-1 font-medium">Holiday Date</label>
                              <div className="bg-white px-3 py-2 rounded text-sm border border-gray-100">
                                {holiday.employee_holiday_date ? moment(holiday.employee_holiday_date).format("MM-DD-YYYY") : "-"}
                              </div>
                            </div>
                            <div className="w-full">
                              <label className="block text-xs text-gray-500 mb-1 font-medium">Notes</label>
                              <div className="bg-white px-3 py-2 rounded text-sm border border-gray-100">{holiday.notes || "-"}</div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-4 bg-gray-50 rounded-lg border border-dashed border-gray-200 flex items-center justify-center">
                          <p className="text-gray-400 text-xs sm:text-sm">
                            No holidays in this timesheet.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Attachments Section */}
                  <div className="my-2">
                    <h2 className="text-primary text-lg font-semibold flex items-center">
                      <MdAttachFile size={20} /> Attachments
                      </h2>
                    <div className="space-y-3 max-h-40 overflow-y-scroll noScrollBarWidth">
                      {data.files?.length > 0 ? (
                        data.files.map((file) => (
                          <div
                            key={file.id}
                            className="flex items-center justify-between p-3 border border-gray-100 rounded-lg bg-gray-50 shadow-sm"
                          >
                            <div className="flex-1 truncate">
                              <span className="text-gray-700 text-sm font-medium">{file.fileName}</span>
                            </div>
                            <MdDownload
                              className={`cursor-pointer w-6 h-6 ml-2 transition-colors duration-150 ${isDownloading
                                ? 'text-gray-400 animate-pulse'
                                : 'text-green-600 hover:text-green-700 hover:scale-110'
                              }`}
                              onClick={() => !isDownloading && onDownload(file.id)}
                              data-tip
                              data-for={`download-${file.id}`}
                            />
                            <CustomToolTip
                              id={`download-${file.id}`}
                              title={isDownloading ? "Downloading..." : "Download File"}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-4 bg-gray-50 rounded-lg border border-dashed border-gray-200 flex items-center justify-center">
                          <p className="text-gray-400 text-xs sm:text-sm">
                            No files available.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Formik>
    );
  };

  return (
    <div className="p-6 w-full h-[90vh]">
      <Loader isLoading={RejectedTimesheets?.loading || DownloadFileByIdReducer?.loading} />
     
      <CustomDataTable
        columns={columns}
        search={search}
        setSearch={setSearch}
        data={RejectedTimesheets?.response?.content || []}
        enableSearch={true}
        serverPagenation
        paginationTotalRows={RejectedTimesheets?.response?.totalElements}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"59vh"}
      />
       {/* Details Modal */}
       <DetailsModal
        isOpen={isModalOpenView}
        onClose={() => setIsModalOpenView(false)}
        data={selectedRow}
        onDownload={downloadFile}
        isDownloading={DownloadFileByIdReducer?.loading}
      />
    </div>
  );
}

export default Hoc(RejectedTimesheets);
